export default __webpack_public_path__ + "images/squire_circle_logo.ed0eea0f92fa71f7677714eb79080ae5.png";